module.exports = __webpack_public_path__ + "static/img/Permiso(17).cfd3a9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/Permiso(17).jpg
// module id = b6mC
// module chunks = 0